module.exports = __webpack_public_path__ + "static/p1-f443243e9b2dc1dfd7b73a9c46c5a477.jpg";